import angular from 'angular';
import moment from "moment";

(function() {
    'use strict';
    angular.module('app.core').factory('RoutingCode', RoutingCode);

    RoutingCode.$inject = ['$translate'];

    function RoutingCode($translate) {
        RoutingCode.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getStatusLabel: getStatusLabel,
            getPdpReDate: getPdpReDate,
            buildPdpRe: buildPdpRe
        };

        function RoutingCode(routingCodeData) {
            if (!routingCodeData) {
                this.buildEmpty();
            } else {
                this.build(routingCodeData);
            }
        }

        return RoutingCode;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.code = null;
            this.label = null;
            this.status = null;
            this.pdpRe = {
                startDate: null,
                endDate: null,
                sentToPpf: false,
                complianceStatus:null,
            };
        }

        function build(routingCode) {
            this.id = routingCode.id || null;
            this.code = routingCode.code || null;
            this.label = routingCode.label || null;
            this.status = routingCode.status || null;
            this.sentToPpf = routingCode.sentToPpf || null;
            this.buildPdpRe(this,routingCode);

        }

        function getStatusLabel() {
            if (this.status) {
                return $translate.instant('kiss_seller.edit.routing_code.status.' + this.status);
            }
            return '';
        }

        function getPdpReDate(dateType){
            return `${this.pdpRe && this.pdpRe[dateType] ? this.pdpRe[dateType].format('DD/MM/YYYY') : '-'} `
        }

        function buildPdpRe(currentObj, routingCode){
            if(routingCode.pdpRe != null){
                currentObj.pdpRe = {
                    startDate : routingCode.pdpRe.startDate ? moment(routingCode.pdpRe.startDate).startOf('day') : null,
                    endDate : routingCode.pdpRe.endDate ? moment(routingCode.pdpRe.endDate).startOf('day') : null,
                    sentToPpf : routingCode.pdpRe.sentToPpf || false,
                    migrationCode: routingCode.pdpRe.migrationCode,
                    complianceStatus: routingCode.pdpRe.complianceStatus,

                };
            }
        }
    }
})();
